export const PLPReviews = [
	{
		title: 'Quick + Easy = Win!',
		stars: 5,
		text: 'I needed a unit to move in same day and am so glad I used self storage. Within 10 minutes I picked the one I wanted from a variety of options, signed up online, and had access to my unit. Being able to do everything online made it so easy and convenient. The information available made it easy to choose which unit & location best suited my needs, and it ensured that I knew everything necessary for renting, paying, insurance, and accessing the unit.',
		customerName: 'Samantha Dumas',
		createdAt: '2023-07-07',
	},
	{
		title: 'Wonderful experience',
		stars: 5,
		text: 'It was great! Upon arriving at storage facility I realized I the unit wasn’t climate controlled. I really needed it to be climate controlled. Called an spoke with Shanice and she fixed me up. The site manager was on site and was also tremendously helpful and friendly. Great customer service all the way around. Very pleased with the whole experience. Thanks',
		customerName: 'Steve Williams',
		createdAt: '2023-07-23',
	},
	{
		title: 'Express check in was super convenient',
		stars: 4,
		text: 'Express check in was super convenient. Everything i needed all in one place, accessible from my phone. Also gave me the option of downloading documents once completed, which was helpful.',
		customerName: 'Elise Francis',
		createdAt: '2023-05-31',
	},
];
